<template>
  <v-dialog v-model="show" width="500px">
    <ModalContentDeposting :onclose="close" />
  </v-dialog>
</template>

<script>
import ModalContentDeposting from './ModalContentDeposting.vue';

export default {
  components: {
    ModalContentDeposting,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>
